// Build WhatsApp deep links with localized, prefilled messages.

const templates = {
  fr: {
    service: (name, price) =>
      `Bonjour, je souhaite prendre rendez-vous pour ${name}${price ? ` à ${price} ₪` : ""}. Quelles sont vos prochaines disponibilités ?`,
    quote: (name) =>
      `Bonjour, je souhaite un devis pour ${name}. Pourriez-vous me recontacter ? Merci.`,
    general: `Bonjour, je souhaite prendre rendez-vous à L'Éclat du Regard. Quelles sont vos disponibilités ?`,
  },
  he: {
    service: (name, price) =>
      `שלום, אני מעוניינת לקבוע תור ל${name}${price ? ` במחיר ${price} ₪` : ""}. מה הזמינות הקרובה שלכם?`,
    quote: (name) =>
      `שלום, אני מעוניינת לקבל הצעת מחיר עבור ${name}. אשמח שתחזרו אליי. תודה.`,
    general: `שלום, אני מעוניינת לקבוע תור במכון "זוהר המבט". מה הזמינות שלכם?`,
  },
  en: {
    service: (name, price) =>
      `Hello, I would like to book an appointment for ${name}${price ? ` at ${price} ₪` : ""}. What is your next availability?`,
    quote: (name) =>
      `Hello, I would like a quote for ${name}. Could you get back to me? Thank you.`,
    general: `Hello, I would like to book an appointment at L'Éclat du Regard. What are your availabilities?`,
  },
};

export function waLink(phoneIntl, message) {
  return `https://wa.me/${phoneIntl}?text=${encodeURIComponent(message)}`;
}

export function serviceWaLink(phoneIntl, lang, name, price, isQuote) {
  const t = templates[lang] || templates.fr;
  const msg = isQuote ? t.quote(name) : t.service(name, price);
  return waLink(phoneIntl, msg);
}

export function generalWaLink(phoneIntl, lang) {
  const t = templates[lang] || templates.fr;
  return waLink(phoneIntl, t.general);
}

const assistantMsg = {
  fr: "Bonjour, je viens du site L'Éclat du Regard et je souhaite prendre rendez-vous. Quelles sont vos prochaines disponibilités ?",
  he: "שלום, הגעתי דרך האתר של זוהר המבט ואני מעוניינת לקבוע תור. מתי יש תור פנוי?",
  en: "Hello, I'm contacting you through the L'Éclat du Regard website. I would like to book an appointment. What are your next available appointments?",
};

export function assistantWaLink(phoneIntl, lang) {
  return waLink(phoneIntl, assistantMsg[lang] || assistantMsg.fr);
}
